import { render, staticRenderFns } from "./ModalEmbed.vue?vue&type=template&id=133e3d90"
import script from "./ModalEmbed.vue?vue&type=script&lang=js"
export * from "./ModalEmbed.vue?vue&type=script&lang=js"
import style0 from "./ModalEmbed.vue?vue&type=style&index=0&id=133e3d90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports